'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var $pdfButton = (0, _jquery2.default)('[data-pdf]');

    if ($pdfButton.length > 0) {
        $pdfButton.click(function (e) {
            e.preventDefault();
            var that = this;

            _jquery2.default.when(_jquery2.default.getScript("/Content/wowbook/pdf.combined.min.js"), _jquery2.default.getScript("/Content/wowbook/wow_book.min.js")).done(function () {
                showPdf(that);
            });
        });
    }

    /* EPub preview Start */
    var displayed = false;
    var epubPreviewLinks = document.querySelectorAll('[data-epub-preview]');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var link = _step.value;

            link.addEventListener('click', function (e) {
                return ePubPreviewClick(e, link);
            });
        };

        for (var _iterator = (0, _getIterator3.default)(epubPreviewLinks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var closeEpuPopup = function closeEpuPopup(book, cover, event) {
        event.preventDefault();
        book.destroy();
        document.body.removeChild(cover);
        document.body.classList.remove('overflow-hidden');
    };

    function ePubPreviewClick(event, link) {
        // adding file with epub extension to the link is here, because otherwise ePub library will screw up the link 
        // and it will look like ../Files/CmsContent/{Guid}/MetaWhatever/whatever.xml and expect some XML, what we won't have in cdn 
        var ePubLink = '' + link.dataset.epubPreview + (!link.dataset.epubPreview.endsWith('/') ? '/' : '') + 'file.epub';

        event.preventDefault();
        var book = ePub(ePubLink);
        var cover = _common2.default.createElement('section', document.body, {
            id: 'ePubCover',
            className: 'wowbook-container-full'
        });
        var epubPreviewArea = _common2.default.createElement('div', cover, {
            id: 'ePubPreviewArea', className: 'wowbook-area ebook-preview-area'
        });
        var loadingElement = _common2.default.createElement('div', epubPreviewArea, {
            id: 'loadingElement',
            className: 'loading'
        });

        var rendition = book.renderTo(epubPreviewArea.id, {
            flow: "paginated",
            width: "100%",
            height: "100%",
            spread: "always"
        });
        displayed = rendition.display();
        document.body.classList.add('overflow-hidden');
        var epubCloseButton = _common2.default.createElement('button', cover, {
            id: 'epubPreviewClose',
            className: 'pdf-close',
            textContent: Resx.Common.Close
        });
        epubCloseButton.addEventListener('click', function (event) {
            return closeEpuPopup(book, cover, event);
        });

        book.ready.then(function () {
            loadingElement.parentElement.removeChild(loadingElement);

            var next = _common2.default.createElement('a', cover, {
                className: 'arrow next',
                id: 'next',
                href: '#next',
                textContent: '›'
            });
            next.addEventListener("click", function (e) {
                book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
                e.preventDefault();
            }, false);

            var prev = _common2.default.createElement('a', cover, {
                className: 'arrow prev',
                id: 'prev',
                href: '#prev',
                textContent: '‹'
            });
            prev.addEventListener("click", function (e) {
                book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
                e.preventDefault();
            }, false);

            var keyListener = function keyListener(event) {
                switch (event.keyCode || event.which) {
                    // Left Key
                    case 37:
                        book.package.metadata.direction === "rtl" ? rendition.next() : rendition.prev();
                        break;
                    // Right Key
                    case 39:
                        book.package.metadata.direction === "rtl" ? rendition.prev() : rendition.next();
                        break;
                    // Escape Key
                    case 27:
                        closeEpuPopup(book, cover, event);
                        break;
                }
            };
            rendition.on("keyup", keyListener);
            document.addEventListener("keyup", keyListener, false);
        });
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

function createCloseButton() {
    var $pdfWrap = (0, _jquery2.default)('.wowbook-container', document);

    // prevent scroll
    (0, _jquery2.default)('body').css('overflow', 'hidden');

    $pdfWrap.append('<button id="pdfClose" class="pdf-close">' + Resx.Common.Close + '</buton>');

    (0, _jquery2.default)('#pdfClose', document).on('click', function (e) {
        e.preventDefault();
        closePDF();
    });
};

function closePDF() {
    (0, _jquery2.default)('.wowbook-container', document).remove();
    (0, _jquery2.default)('body').css('overflow', 'initial');
    (0, _jquery2.default)('.ie11 body', document).attr('style', '');
    _common2.default.addRemoveClass('.mobile-floating-footer', 'hidden', false, false);
}

function showPdf(elm) {
    var $this = (0, _jquery2.default)(elm);

    (0, _jquery2.default)('body').append('<div id="wowBook" />');

    var bookOptions = {
        pdf: $this.data('pdf'),

        height: 600,
        width: 800,
        maxHeight: 800,
        centeredWhenClosed: true,
        hardcovers: true,
        pageNumbers: false,
        toolbar: "lastLeft, left, right, lastRight, zoomin, zoomout, slideshow, download",
        thumbnailsPosition: 'left',
        responsiveHandleWidth: 50,
        container: window,
        containerPadding: "20px",
        flipSound: false,
        deepLinking: false,
        updateBrowserURL: false,
        pageFlipDuration: 0,
        turnPageDuration: 0,
        useTranslate3d: false,
        useScale3d: false,
        mobile: false,
        onPDFLoadError: function onPDFLoadError(e) {
            _notify2.default.error(Resx.App.PdfNotFound);
            closePDF();
        }
    };

    (0, _jquery2.default)('#wowBook').wowBook(bookOptions); // create the book

    createCloseButton();
    // hide bottom bar on pdf preview
    _common2.default.addRemoveClass('.mobile-floating-footer', 'hidden', true, false);

    (0, _jquery2.default)('.wow').removeClass('wow');
}

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/pdfPopup.js
// module id = 1077
// module chunks = 1